<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <div>
            <span>下级总数：</span>
            {{ pageCount }}
          </div>
        </div>
        <div class="header-right"></div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="distributionList" style="width: 100%;">
            <el-table-column label="id">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.dealerId }}</div>
              </template>
            </el-table-column>
            <el-table-column label="昵称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.nickName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="手机号">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.phoneNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="加入时间">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.createTime }}</div>
              </template>
            </el-table-column>
            <el-table-column label="总金额">
              <template slot-scope="scope">
                <div class="name">
                  {{
                    scope.row.totalAmount ? `￥${scope.row.totalAmount}` : `￥0`
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单数">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.orderCount ? `${scope.row.orderCount}` : `0` }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="最后购买时间">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.lastBuyTime }}</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDealerChildListPage, getDealerChildCount } from "@/api/index.js";
export default {
  data() {
    return {
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未分佣",
          value: 0,
        },
        {
          label: "已分佣",
          value: 1,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      distributionList: [],
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      phoneNum: "",
      distributionCount: 0,
    };
  },
  watch: {
    time(val) {
      console.log(val);
      if (val) {
        this.startTime = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endTime = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getDealerChildListPage();
      // this.getDealerChildCount();
    },
    getDealerChildListPage() {
      getDealerChildListPage({
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        fatherUserId: this.$route.query.userId,
      }).then((res) => {
        if (res.code == 1) {
          this.distributionList = res.data.list;
          this.pageCount = res.data.totalCount;
        }
        if (res.code == -1) {
          this.distributionList = [];
          this.pageCount = 0;
        }
      });
    },
    getDealerChildCount() {
      getDealerChildCount({
        fatherUserId: this.$route.query.userId,
      }).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.distributionCount = res.data.totalCount;
        }
      });
    },
    searchDistribution() {
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDealerChildListPage();
    },
    linkToRelationship(userId) {
      this.$router.push({
        path: "/distribution/relationship",
        query: {
          userId: userId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-left {
    height: 30px;
    align-items: center;
  }
  .header-right {
    & > div {
      .el-input {
        display: inline-block;
        width: 130px;
      }
    }
    & > div + div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
